import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toastService } from "../utils/toastify";
import { useDispatch } from "react-redux";
const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    localStorage.removeItem("adminLogin");
    toastService.success("Logged out successfully!");
    return navigate("/login");
  }, []);
};

export default Logout;
